export default __webpack_public_path__ + "static/media/M3.1a529221.png";